import { CreateUserRequestDto } from '@tradgine/data-access/auth';
import { UpdateOrganizationUser } from '../domain/update-organization-user.model';

export function toUpdateUserRequestDto(model: UpdateOrganizationUser): CreateUserRequestDto {
    return {
        organizationId: model.organizationId,
        id: model.id.toString(),
        login: model.login,
        fullName: model.fullName,
        email: model.email,
        phoneNumber: model.phoneNumber,
        position: model.position,
        roles: model.roles,
        status: model.status,
    };
}
